import { render, staticRenderFns } from "./MultiAllocationDialog.vue?vue&type=template&id=44a3d2a4&"
import script from "./MultiAllocationDialog.vue?vue&type=script&lang=js&"
export * from "./MultiAllocationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports